import styled from 'styled-components'

import { PhoneInput } from '@/components/ui/phone-input'

export const Container = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['4'],
  paddingBottom: theme.space['22'],
  position: 'relative',
  width: '100%',
}))

export const Label = styled.label(({ theme }) => ({
  color: theme.colors.black800,
  fontSize: '1.4rem',
  fontWeight: 600,
}))

// Note: Override the UI PhoneInput styles to match visitor-parking design.
// PhoneInput now renders on top of TextInput, so the field chrome (border +
// background) lives on the inner `<label>` wrapper rather than on the button/input.
export const StyledPhoneInput = styled(PhoneInput)<{ $hasError: boolean }>(
  ({ theme, $hasError }) => ({
    // Container > Field > InputWrapper(label) — the bordered field box.
    '& > div > label': {
      background: $hasError ? theme.colors.red100 : theme.colors.gray100,
      borderColor: $hasError ? theme.colors.visitorParkingErrorText : theme.colors.gray500,
    },
    '& input': {
      fontSize: '1.6rem',
    },
  }),
)

export const ErrorMessage = styled.p(({ theme }) => ({
  bottom: 0,
  color: theme.colors.visitorParkingErrorText,
  fontSize: '1.2rem',
  fontWeight: 500,
  left: 0,
  maxWidth: '100%',
  overflow: 'hidden',
  position: 'absolute',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}))

export const ExtraInfo = styled.p(({ theme }) => ({
  bottom: 0,
  color: theme.colors.black500,
  fontSize: '1.2rem',
  fontWeight: 500,
  left: 0,
  position: 'absolute',
}))
